import {call, put, takeLatest} from 'redux-saga/effects';
import MyTop10GamesApi from '../../api/MyTop10GamesApi';
import myTop10GamesActions from '../../actions/fortnite-game/myTop10Games.actions';
import getErrorCodeFromResponse from '../../utils/errors/getErrorCodeFromResponse';
import {NO_DATA_ERROR_CODE} from './constants';

function* getMyTop10Games(action) {
    try {
        const {data} = yield call(MyTop10GamesApi.getMyTop10Games, action.payload);
        yield put(
            myTop10GamesActions.getMyTop10GamesSuccess({
                data,
                error: data.length ? undefined : NO_DATA_ERROR_CODE,
                ...action.payload
            })
        );
    } catch (e) {
        yield put(
            myTop10GamesActions.getMyTop10GamesFailed(getErrorCodeFromResponse(e), {
                ...action.payload,
                ...e
            })
        );
    }
}

function* myTop10GamesSaga() {
    yield takeLatest(myTop10GamesActions.TYPES.GET_TOP_10_GAMES, getMyTop10Games);
}

export default myTop10GamesSaga;
